import { render, staticRenderFns } from "./CatalogItemBasket.vue?vue&type=template&id=03acdd04&"
import script from "./CatalogItemBasket.vue?vue&type=script&lang=js&"
export * from "./CatalogItemBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports